import { DefaultPrimaryButton } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';

export interface GenerateButtonProps {
    onClick: () => void;
    text: React.ReactNode;
}

export const GenerateModalButton = (props: GenerateButtonProps) => {
    return (
        <DefaultPrimaryButton
            onClick={props.onClick}
            text={CommonMessage.BUTTONS.GENERATE(props.text)}
        />
    );
};
